import { Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { debounceTime } from 'rxjs';
import { EcatalogService } from 'src/app/services/ecatalog.service';
import { SharedDataService } from 'src/app/services/sharedDataService.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.less']
})
export class SearchComponent implements OnInit {
  @ViewChild('searchResult', { static: false }) myDiv!: ElementRef;
  @ViewChild('vinDiv', { static: false }) vinDiv!: ElementRef;
  tabSelectedIndex: number = 0
  searchType: string = "vin";
  auAreaList: string[] = ["ACT", "NSW", "NT", "QLD", "SA", "TAS", "VIC", "WA"];
  searchFormData!: FormGroup;
  searchResults: any[] = [];
  manuList: any[] = [];
  modelList: any[] = [];
  yearList: any[] = [];
  displacementList: any[] = [];
  typeList: any[] = [];
  isHistory: boolean = false;
  historyResults: string[] = [];
  @Output() vehicleSelected: EventEmitter<any> = new EventEmitter<any>();
  showResult: boolean = false;
  searchTypeList: string[] = ['vin', 'vehicle', 'product'];
  isTypeChange: boolean = false;
  isModelChange: boolean = false;
  isYearChange: boolean = false;
  isDisplacementChange: boolean = false;
  selectedResults: any[] = [];// vin select
  isDealerPortal: boolean = false;
  constructor(private fb: FormBuilder, private ecatalogService: EcatalogService,
    private sharedData: SharedDataService
  ) {
    this.sharedData.currentData.subscribe(data => {
      this.isDealerPortal = data.isDealerPortal;
    });
  }

  // 监听全局点击事件
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    // 如果点击的目标不在 myDiv 之内，触发事件
    if (!this.myDiv?.nativeElement?.contains(event.target) && this.searchType == 'vin' && !this.vinDiv.nativeElement.contains(event.target)) {
      this.showResult = false;
    }
  }

  changeTab(index: number): void {
    this.tabSelectedIndex = index;
    this.changeType(this.searchTypeList[index]);
  }

  search(number: string) {
    const term = this.searchFormData.get(number)?.value.trim();
    if (term.length === 0) {
      let historyType = '';
      switch (this.searchType) {
        case 'rego':
          historyType = this.searchFormData.get('country')?.value === 'au' ? 'au_rego_list' : 'nz_rego_list';
          break;
        case 'vin':
          historyType = 'vin_list';
          break;
        case 'vehicle':
          historyType = 'vehicle_list';
          break;
        case 'product':
          historyType = 'product_list';
          break;
      }
      this.historyResults = JSON.parse(localStorage.getItem(historyType) || '[]');
      if (this.historyResults.length > 0) {
        this.showResult = true;
      }
      this.isHistory = true;
      this.searchResults = this.historyResults;
    } else {
      this.isHistory = false;
      switch (this.searchType) {
        case 'rego':
          this.showResult = true;
          this.queryVehiclesByKeyNumberPlate();
          break;
        case 'vin':
          this.showResult = true;
          this.queryVehiclesByVin();
          break;
        case 'vehicle':
          this.showResult = true;
          this.linkageTargePage();
          break;
        case 'product':
          this.showResult = false;
          this.searchResults = [];
          break;
      }
    }
  }

  changeCountry(): void {
    this.searchFormData.get('regoNo')?.setValue("");
  }

  ngOnInit(): void {
    this.searchFormData = this.fb.group({
      areaCode: [null, []],
      regoNo: ['', []],
      vinNo: ['', []],
      product: ['', []],
      vehicle: ['', []],
      manu: ['', []],
      model: ['', []],
      type: ['', []],
      year: [[], []],
      displacement: [[], []],
      country: ['AU', []],
    });
    this.searchFormData.get('regoNo')?.valueChanges.pipe(
      debounceTime(500) // 防抖处理输入
    ).subscribe(() => {
      this.search('regoNo');
    });
    this.searchFormData.get('vinNo')?.valueChanges.pipe(
      debounceTime(500) // 防抖处理输入
    ).subscribe(() => {
      this.search('vinNo');
    });
    this.searchFormData.get('vehicle')?.valueChanges.pipe(
      debounceTime(500)
    ).subscribe(() => {
      this.search('vehicle');
    });
    this.searchFormData.get('product')?.valueChanges.pipe(
      debounceTime(500)
    ).subscribe(() => {
      this.search('product');
    });
  }
  onBlur(time?: number): void {
    setTimeout(() => {
      this.showResult = false;
    }, time ?? 1000);
  }
  changeType(type: string): void {
    this.searchType = type;
    this.searchResults = [];
    this.showResult = false;
    if (type === 'vehicle') {
      this.manuList = [];
      this.modelList = [];
      this.yearList = [];
      this.displacementList = [];
      this.typeList = [];
      this.searchFormData.get('manu')?.setValue("");
      this.searchFormData.get('type')?.setValue("");
      this.searchFormData.get('model')?.setValue("");
      this.searchFormData.get('year')?.setValue([]);
      this.searchFormData.get('displacement')?.setValue([]);
      this.getManufacturers();
      this.chooseVehicleType()
    }else if(type === 'vin'){
      this.queryVehicleModel([])
    }else if(type === 'product'){
      this.queryVehicleModel("")
    }
  }
  getManufacturers(): void {
    this.ecatalogService.getManufacturers({}).subscribe(res => {
      this.manuList = res.rtnData || [];
    });
  }
  clear(): void {
    this.modelList = [];
    this.yearList = [];
    this.displacementList = [];
    this.typeList = [];
    this.searchFormData.get('manu')?.setValue("");
    this.isTypeChange = true;
    this.searchFormData.get('type')?.setValue("");
    this.isModelChange = true;
    this.searchFormData.get('model')?.setValue("");
    this.isYearChange = true;
    this.searchFormData.get('year')?.setValue([]);
    this.isDisplacementChange = true;
    this.searchFormData.get('displacement')?.setValue([]);

    this.chooseVehicleType()
  }
  queryVehicleModelSeries(): void {
    this.isTypeChange = true;
    this.searchFormData.get('type')?.setValue("");
    this.isModelChange = true;
    this.searchFormData.get('model')?.setValue("");
    this.isYearChange = true;
    this.searchFormData.get('year')?.setValue([]);
    this.isDisplacementChange = true;
    this.searchFormData.get('displacement')?.setValue([]);
    this.typeList = []
    this.modelList = []
    this.yearList = [];
    this.displacementList = [];
    this.ecatalogService.queryVehicleModelSeries({
      "manuId": this.searchFormData.get('manu')?.value
    }).subscribe(res => {
      this.modelList = res.rtnData || [];
    });
    if (environment.production) {
      const userData = JSON.parse(localStorage.getItem('userData') || '{}');
      const customer = JSON.parse(localStorage.getItem('customer') || '{}');
      (window as any).dataLayer.push({
        event: 'dp_eact_search_click',
        from_page: (localStorage.getItem('token') ? 'afterLogin ' : 'beforeLogin ') + window.location.pathname,
        event_type: 'vehicle',
        event_name: '',
        portal_name: 'PC ' + (this.isDealerPortal ? "DealerPortal " + customer?.customerCode : "SalesPortal " + userData?.queryUserPageInfoResDTO?.ntAccount),
        event_content: this.searchFormData.get('manu')?.value,
      });
    }
  }
  queryDisplacement(): void {
    if (this.isTypeChange) {
      this.isTypeChange = false;
      return;
    }
    this.isYearChange = true;
    this.searchFormData.get('year')?.setValue([]);
    this.isDisplacementChange = true;
    this.searchFormData.get('displacement')?.setValue([]);
    this.ecatalogService.queryDisplacement({
      "brandId": this.searchFormData.get('manu')?.value,
      "modelId": this.searchFormData.get('type')?.value
    }).subscribe(res => {
      this.displacementList = res.rtnData.displacementList;
      this.chooseVehicleType();
    });
    if (environment.production) {
      const userData = JSON.parse(localStorage.getItem('userData') || '{}');
      const customer = JSON.parse(localStorage.getItem('customer') || '{}');
      (window as any).dataLayer.push({
        event: 'dp_eact_search_click',
        from_page: (localStorage.getItem('token') ? 'afterLogin ' : 'beforeLogin ') + window.location.pathname,
        event_type: 'vehicle',
        event_name: '',
        portal_name: 'PC ' + (this.isDealerPortal ? "DealerPortal " + customer?.customerCode : "SalesPortal " + userData?.queryUserPageInfoResDTO?.ntAccount),
        event_content: this.searchFormData.get('manu')?.value + " " + this.searchFormData.get('type')?.value,
      });
    }
  }
  queryVehicleTypeSeries(): void {
    if (this.isTypeChange) {
      this.isTypeChange = false;
      return;
    }
    if (this.isModelChange) {
      this.isModelChange = false;
      return;
    }
    this.yearList = [];
    this.displacementList = [];
    this.isTypeChange = true;
    this.searchFormData.get('type')?.setValue("");
    this.isDisplacementChange = true;
    this.searchFormData.get('displacement')?.setValue([]);
    this.isYearChange = true;
    this.searchFormData.get('year')?.setValue([]);
    this.ecatalogService.queryVehicleTypeSeries({
      "manuId": this.searchFormData.get('manu')?.value,
      "modelClass": this.searchFormData.get('model')?.value?.name,
      "manufacturer": this.searchFormData.get('model')?.value?.manufacturer,
      "modelId": this.searchFormData.get('model')?.value?.id
    }).subscribe(res => {
      const { linkageTargetVoList, displacementList, modelYearList } = res.rtnData;
      this.typeList = linkageTargetVoList || [];
      this.yearList = modelYearList || [];
      this.displacementList = displacementList || [];
    });
    if (environment.production) {
      const userData = JSON.parse(localStorage.getItem('userData') || '{}');
      const customer = JSON.parse(localStorage.getItem('customer') || '{}');
      (window as any).dataLayer.push({
        event: 'dp_eact_search_click',
        from_page: (localStorage.getItem('token') ? 'afterLogin ' : 'beforeLogin ') + window.location.pathname,
        event_type: 'vehicle',
        event_name: '',
        portal_name: 'PC ' + (this.isDealerPortal ? "DealerPortal " + customer?.customerCode : "SalesPortal " + userData?.queryUserPageInfoResDTO?.ntAccount),
        event_content: this.searchFormData.get('model')?.value?.manufacturer + " " + this.searchFormData.get('model')?.value?.name,
      });
    }
  }
  queryVehiclesByKeyNumberPlate(): void {
    let params = {
      "areaCode": this.searchFormData.get('country')?.value === 'AU' ? this.searchFormData.get('areaCode')?.value : undefined, //"VIC"
      "numberPlate": this.searchFormData.get('regoNo')?.value//"1SF6BE"
    };
    this.ecatalogService.queryVehiclesByKeyNumberPlate(params).subscribe(res => {
      this.searchResults = res.rtnData;
    })
  }

  toggleSelection(result: any, event: MouseEvent): void {
    const index = this.selectedResults.indexOf(result);
    if (index === -1) {
      this.selectedResults.push(result);
    } else {
      this.selectedResults.splice(index, 1);
    }
    this.queryVehicleModel(this.selectedResults);
  }

  isSelected(result: any): boolean {
    return this.selectedResults.includes(result);
  }

  queryVehiclesByVin(): void {
    this.selectedResults = [];
    let params = {
      "maxVehiclesToReturn": -1,
      "vin": this.searchFormData.get('vinNo')?.value
    };
    this.ecatalogService.queryVehiclesByVin(params).subscribe(res => {
      this.searchResults = res.rtnData;
    })
    if (environment.production) {
      const userData = JSON.parse(localStorage.getItem('userData') || '{}');
      const customer = JSON.parse(localStorage.getItem('customer') || '{}');
      (window as any).dataLayer.push({
        event: 'dp_eact_search_click',
        from_page: (localStorage.getItem('token') ? 'afterLogin ' : 'beforeLogin ') + window.location.pathname,
        event_type: 'VIN',
        event_name: '',
        portal_name: 'PC ' + (this.isDealerPortal ? "DealerPortal " + customer?.customerCode : "SalesPortal " + userData?.queryUserPageInfoResDTO?.ntAccount),
        event_content: this.searchFormData.get('vinNo')?.value,
      });
    }
  }
  setProduct(item: any): void {

  }
  queryArticleByArticles(item: any): void {
    if (item.trim().length > 0) {
      this.searchResults = [];
      let historyList: any[] = JSON.parse(localStorage.getItem('product_list') || '[]');
      if (!historyList.includes(item)) {
        historyList.unshift(item);
        if (historyList.length > 5) {
          historyList.pop();
        }
        localStorage.setItem('product_list', JSON.stringify(historyList));
      }
      let data = {
        vehicle: item,
        type: "product"
      };
      this.vehicleSelected.emit(data);
      if (environment.production) {
        const userData = JSON.parse(localStorage.getItem('userData') || '{}');
        const customer = JSON.parse(localStorage.getItem('customer') || '{}');
        (window as any).dataLayer.push({
          event: 'dp_eact_search_click',
          from_page: (localStorage.getItem('token') ? 'afterLogin ' : 'beforeLogin ') + window.location.pathname,
          event_type: 'PN',
          event_name: '',
          portal_name: 'PC ' + (this.isDealerPortal ? "DealerPortal " + customer?.customerCode : "SalesPortal " + userData?.queryUserPageInfoResDTO?.ntAccount),
          event_content: item,
        });
      }
    }
  }
  chooseVehicleType(): void {
    if (this.isYearChange) {
      this.isYearChange = false;
      return;
    }
    if (this.isDisplacementChange) {
      this.isDisplacementChange = false;
      return;
    }
    let item = this.typeList.filter((data: any) => data.modelId == this.searchFormData.get('type')?.value);
    this.queryVehicleModel(
      {
        ...item,
        "year": this.searchFormData.get('year')?.value,
        "displacement": this.searchFormData.get('displacement')?.value,
        "manuId": this.searchFormData.get('manu')?.value,
        "modelClass": this.searchFormData.get('model')?.value?.name, "manufacturer": this.searchFormData.get('model')?.value?.manufacturer, "modelId": this.searchFormData.get('type')?.value
      }
      , false);
    if (environment.production) {
      const userData = JSON.parse(localStorage.getItem('userData') || '{}');
      const customer = JSON.parse(localStorage.getItem('customer') || '{}');
      (window as any).dataLayer.push({
        event: 'dp_eact_search_click',
        from_page: (localStorage.getItem('token') ? 'afterLogin ' : 'beforeLogin ') + window.location.pathname,
        event_type: 'vehicle',
        event_name: '',
        portal_name: 'PC ' + (this.isDealerPortal ? "DealerPortal " + customer?.customerCode : "SalesPortal " + userData?.queryUserPageInfoResDTO?.ntAccount),
        event_content: this.searchFormData.get('model')?.value?.manufacturer + " " + this.searchFormData.get('model')?.value?.name + " " + this.searchFormData.get('year')?.value + " " + this.searchFormData.get('displacement')?.value,
      });
    }
  }
  queryVehicleModel(item: any, needRecord: boolean = true): void {
    let data = {
      vehicle: item,
      type: this.searchType
    };
    switch (this.searchType) {
      case 'rego':
        if (this.searchFormData.get('country')?.value === 'au') {
          var historyList: any[] = JSON.parse(localStorage.getItem('au_rego_list') || '[]');
          if (!historyList.includes(item)) {
            historyList.unshift(item);
            if (historyList.length > 5) {
              historyList.pop();
            }
            localStorage.setItem('au_rego_list', JSON.stringify(historyList));
          }
        } else {
          var historyList: any[] = JSON.parse(localStorage.getItem('nz_rego_list') || '[]');
          if (!historyList.includes(item)) {
            historyList.unshift(item);
            if (historyList.length > 5) {
              historyList.pop();
            }
            localStorage.setItem('nz_rego_list', JSON.stringify(historyList));
          }
        }
        this.vehicleSelected.emit(data);
        this.showResult = false;
        break;
      case 'vin':
        var historyList: any[] = JSON.parse(localStorage.getItem('vin_list') || '[]');
        item.forEach((i: any) => {
          if (!historyList.some(entry => entry.carId == i.carId)) {
            historyList.unshift(i);
            if (historyList.length > 5) {
              historyList.pop();
            }
          }
        })
        localStorage.setItem('vin_list', JSON.stringify(historyList));
        this.vehicleSelected.emit(data);
        //this.searchResults=[];
        break;
      case 'vehicle':
        if (needRecord) {
          var historyList: any[] = JSON.parse(localStorage.getItem('vehicle_list') || '[]');
          if (!historyList.some(entry => entry.linkageTargetId === item.linkageTargetId)) {
            historyList.unshift(item);
            if (historyList.length > 5) {
              historyList.pop();
            }
            localStorage.setItem('vehicle_list', JSON.stringify(historyList));
          }
          this.searchFormData.get('manu')?.setValue("");
          this.searchFormData.get('type')?.setValue("");
          this.searchFormData.get('model')?.setValue("");
        }
        this.vehicleSelected.emit(data);
        this.searchResults = [];
        this.showResult = false;
        break;
      case 'product':
        this.searchResults = [];
        this.vehicleSelected.emit(data);
        this.showResult = false;
        break;

    }
  }

  getFormattedLabel(model: any): string {
    if (model && model.name) {
      return `${model.manufacturer} - ${model.name} `
    }
    return '';
  }
  getFormattedTypeLabel(model: any): string {
    //+ ' | ' + model.kiloWattsFrom + 'kw | ' + model.horsePowerFrom + 'hp'
    return model.description;
  }

  linkageTargePage(): void {
    let params = {
      "current": 1,
      "query": this.searchFormData.get('vehicle')?.value,
      "size": 15
    };
    this.ecatalogService.linkageTargePage(params).subscribe(res => {
      this.searchResults = res.rtnData.records;
    });
  }

  queryArticleByAnyNumber(): void {

    let params = {
      "current": 1,
      "query": this.searchFormData.get('vehicle')?.value,
      "size": 15
    };
    this.ecatalogService.queryArticleByLinkTarget(params).subscribe(res => {
      this.searchResults = res.rtnData.records;
    });
  }


  queryArticleByLinkTarget(): void {

    let params = {
      "current": 1,
      "linkageTargetId": 0,
      "linkageTargetType": "",
      "query": this.searchFormData.get('vehicle')?.value ?? undefined,
      "size": 15
    };
    this.ecatalogService.queryArticleByLinkTarget(params).subscribe(res => {

    });
  }

}
